<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Moving Floor Trailer Rental</h1>
    	      <p class="lead grey">Rent a Moving Floor Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Moving Floor Trailer that fit your transportation needs. Simply request your Moving Floor Trailer available for short-term rental with PNO Rental.</p>
    				<p><a href="/trailers?category=movingfloor" class="btn btn-lg btn-success">Search Moving Floor Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
            <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_moving-floor.jpg')" class="img-fluid mb-3" alt="Moving Floor Trailer Rental">
            </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Moving Floor Trailer Features</h2>
    	<p class="lead grey">Moving floor trailers are the most common choice for transportation of garbage, scrap, agricultural products, wood, glass and peat.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">Standard specification for transportation of pallets and bulk load.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Opening Side</h5>
    			<p class="grey">Opening side for loading of bulk and bulky goods.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Hydraulic</h5>
    			<p class="grey">Hydraulic opening side for loading of extra-long or bulky goods.</p>
    	  </div>
    	</div>
      <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';

export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Moving Floor Trailer for Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Moving Floor Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_moving-floor.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
